"use client";

interface VoteButtonsProps {
  upvotes: number;
  downvotes: number;
  userVote: boolean | undefined;
  onVote: (isUpvote: boolean) => void;
  size?: "sm" | "md";
}

/**
 * Reusable vote up/down buttons. Used on meals and weekend suggestions.
 * Shows thumbs up/down with counts, highlights the user's current vote.
 */
export function VoteButtons({
  upvotes,
  downvotes,
  userVote,
  onVote,
  size = "sm",
}: VoteButtonsProps) {
  const px = size === "sm" ? "px-1.5 py-0.5" : "px-2 py-1";
  const iconSize = size === "sm" ? 12 : 14;
  const textSize = size === "sm" ? "text-xs" : "text-xs";

  return (
    <div className="flex items-center gap-1.5">
      <button
        onClick={() => onVote(true)}
        className={`flex items-center gap-0.5 ${px} rounded ${textSize} transition-colors ${
          userVote === true
            ? "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400"
            : "bg-gray-100 text-gray-400 dark:bg-white/10 dark:text-gray-500 hover:bg-gray-200 dark:hover:bg-white/15"
        }`}
      >
        <svg
          width={iconSize}
          height={iconSize}
          viewBox="0 0 24 24"
          fill={userVote === true ? "currentColor" : "none"}
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
        </svg>
        {upvotes > 0 && upvotes}
      </button>
      <button
        onClick={() => onVote(false)}
        className={`flex items-center gap-0.5 ${px} rounded ${textSize} transition-colors ${
          userVote === false
            ? "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400"
            : "bg-gray-100 text-gray-400 dark:bg-white/10 dark:text-gray-500 hover:bg-gray-200 dark:hover:bg-white/15"
        }`}
      >
        <svg
          width={iconSize}
          height={iconSize}
          viewBox="0 0 24 24"
          fill={userVote === false ? "currentColor" : "none"}
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17" />
        </svg>
        {downvotes > 0 && downvotes}
      </button>
    </div>
  );
}
